import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AwardFormPage from './FormPage';

export default function TournamentAwardsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/new`} component={AwardFormPage} />
      <Route path={`${match.url}/:awardId`} component={AwardFormPage} />
    </Switch>
  );
}
